// @ts-strict-ignore
import React from 'react'
import { connect } from 'react-redux'
import { useEntities } from '../helpers/selectors'
import { Label, Card, RadioGroup, CriticalRadio } from '../../atoms'
import Image from '../imgix-img'
import ProductTable from '../product-table/table.connected'
import { findEntityBySysId } from '../../redux/contentful-selectors'

const ProductSelector = ({
  title,
  subtitle,
  productTablesEntities,
  iconListEntities,
  iconImages,
  ...props
}) => {
  return (
    <div data-tabs-selector={title}>
      <Card className='ProductSelector' variant='plum'>
        <h2 className='ProductNavigation__title'>{title}</h2>

        <div className='ProductNavigation__inner-card'>
          <Label>{subtitle}</Label>
          <RadioGroup stack={true}>
            {iconListEntities.map((icon, index) => {
              const imgIcon = iconImages[index]
              return (
                <CriticalRadio
                  key={index}
                  onClick={() => {}}
                  name={`product-selector-${title}`}
                  centerLabel={true}
                  buttonAlignment={'top-left'}
                  checked={index === 0}
                  buttonActions={{
                    /* eslint-disable camelcase */
                    'data-tabs-selector-radio': index,
                    'data-click-tracking': JSON.stringify({
                      component_category: 'product selector',
                      component_id: props.sys?.id,
                      component_name: 'productSelector',
                      contentful_name: props.name,
                      additionalProps: {
                        name: icon.text,
                        index,
                      },
                    }),
                  }}
                >
                  <div className='ProductNavigation__radioButton'>
                    <Image
                      src={imgIcon.file.url}
                      alt={imgIcon.title}
                      width={32}
                      height={32}
                      critical={true}
                    />
                    <div className='ProductNavigation__radioButton__text'>
                      <span className='ProductNavigation__radioButton__label'>{icon.text}</span>
                    </div>
                  </div>
                </CriticalRadio>
              )
            })}
          </RadioGroup>
        </div>

        {productTablesEntities.map((productTable, index) => {
          return (
            <div
              key={index}
              data-tabs-selector-content
              style={{ display: index === 0 ? 'block' : 'none' }}
            >
              <ProductTable {...productTable} />
            </div>
          )
        })}
      </Card>
    </div>
  )
}

export default connect((state, props) => {
  const productTablesEntities = useEntities(props.productTables)
  const iconListEntities = useEntities(props.iconList)
  const iconImages = iconListEntities.map(
    (icon) => findEntityBySysId(state, icon.icon.sys.id).fields,
  )

  return {
    ...props,
    productTablesEntities,
    iconListEntities,
    iconImages,
  }
})(ProductSelector)
